import { useContext} from 'react';
import ReactDOM from 'react-dom';

//context
import {ListContext} from '@/context/ListContext';
import MainMenuListContextProvider from '@/context/MainMenuListContext';

//component
import MainMenu from  '@/components/page/Content/Menu/MainMenu';



const MainMenuPortal = () =>  {
    // Container ref
    const targetContainer = document.getElementById('react-main-menu-portal');
    const {setAppId, setAppGuid, setListId, listId, setListContentPermission, setOrgPermission, setIsCombinedFeedEnabled} = useContext(ListContext)

    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    else {
        setAppGuid(targetContainer?.getAttribute?.('data-app-guid'));
        setAppId(targetContainer?.getAttribute?.('data-app-id'));
        setOrgPermission(targetContainer?.getAttribute?.('data-orgpermission'));
        setListContentPermission(targetContainer?.getAttribute?.('data-contentpermission'));
        setIsCombinedFeedEnabled(targetContainer?.getAttribute?.('data-combinedfeedenabled')?.toLocaleLowerCase() === 'true');

        if(!listId  || listId ==='0') {
            setListId(targetContainer?.getAttribute?.('data-menu-id'))
        }
    }

    return ReactDOM.createPortal(
        <MainMenuListContextProvider>
            <MainMenu />
        </MainMenuListContextProvider>
        , targetContainer
    );
  
}

export default MainMenuPortal;